import { claimReferralCode } from "../api";

const REF_PENDING_KEY = "csb_referral_pending_code";
const REF_LAST_CLAIM_KEY = "csb_referral_last_claim";

function canUseStorage() {
  return typeof window !== "undefined" && !!window.localStorage;
}

export function normalizeReferralCode(raw) {
  const code = String(raw || "").trim();
  return code || "";
}

export function persistReferralCodeFromSearch(search = "") {
  if (!canUseStorage()) return "";
  const params = new URLSearchParams(search || "");
  const code = normalizeReferralCode(params.get("ref"));
  if (!code) return "";

  const existing = normalizeReferralCode(window.localStorage.getItem(REF_PENDING_KEY));
  if (existing !== code) {
    window.localStorage.setItem(REF_PENDING_KEY, code);
    window.localStorage.removeItem(REF_LAST_CLAIM_KEY);
  }
  return code;
}

export function getPendingReferralCode() {
  if (!canUseStorage()) return "";
  return normalizeReferralCode(window.localStorage.getItem(REF_PENDING_KEY));
}

export function getLastReferralClaimResult() {
  if (!canUseStorage()) return null;
  try {
    const raw = window.localStorage.getItem(REF_LAST_CLAIM_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function setLastReferralClaimResult(payload) {
  if (!canUseStorage()) return;
  window.localStorage.setItem(REF_LAST_CLAIM_KEY, JSON.stringify({
    ...payload,
    at: new Date().toISOString(),
  }));
}

function clearPendingReferralCode() {
  if (!canUseStorage()) return;
  window.localStorage.removeItem(REF_PENDING_KEY);
}

export async function claimPendingReferralCodeOnce({ force = false } = {}) {
  const code = getPendingReferralCode();
  if (!code) return { status: "no_code" };

  const last = getLastReferralClaimResult();
  if (!force && last?.code === code && last?.attempted) {
    return { status: "skipped", code, last };
  }

  try {
    const data = await claimReferralCode(code);
    const result = {
      attempted: true,
      code,
      status: "success",
      message: "Referral linked successfully.",
      response: data || null,
    };
    setLastReferralClaimResult(result);
    clearPendingReferralCode();
    return result;
  } catch (err) {
    const statusCode = err?.response?.status;
    let status = "error";
    let message =
      err?.response?.data?.detail ||
      err?.message ||
      "Could not apply referral code.";

    if (statusCode === 409) {
      status = "already_claimed";
      message = "Referral already claimed on this account.";
      clearPendingReferralCode();
    } else if (statusCode === 404) {
      status = "invalid";
      message = "Referral code is invalid or no longer available.";
      clearPendingReferralCode();
    }

    const result = {
      attempted: true,
      code,
      status,
      statusCode: statusCode || null,
      message,
    };
    setLastReferralClaimResult(result);
    return result;
  }
}

